/* eslint-disable react/no-set-state */
import PropTypes from 'prop-types';

import React, { Component } from 'react';
import DropdownIcon from './dropdownIcon';
import { Tooltip } from 'react-tippy';
import './index.scss';
export default class IconRenderer extends Component {
  static propTypes = {
    data: PropTypes.any,
    icons: PropTypes.any,
    value: PropTypes.any,
  };

  renderItem(component, index) {
    const { value, data } = this.props;
    const content = component.isDropdown ? (
      <DropdownIcon
        items={component.items}
        key={index}
        label={component.label}
        value={value}
      />
    ) : (
      <a
        key={index}
        style={{ cursor: 'pointer' }}
        onClick={() => component.onClick(value, data)}
      >
        {component.label ? (
          <span>{component.label}</span>
        ) : (
          <i
            className={`icon ${
              component.getIcon
                ? component.getIcon(data.active, data)
                : component.icon
            }`}
            style={component.style}
          />
        )}
      </a>
    );
    if (component.tooltip) {
      return (
        <Tooltip
          html={<div>{component.tooltip}</div>}
          key={index}
          position="bottom"
          trigger="mouseenter"
        >
          {content}
        </Tooltip>
      );
    }
    return content;
  }

  render() {
    const { icons } = this.props;
    return (
      <div className="ag-grid-action-container">
        <div style={{ display: 'flex', justifyContent: 'space-around' }}>
          {icons.map((component, index) => this.renderItem(component, index))}
        </div>
      </div>
    );
  }
}
